import React from "react";
import { Box, Typography, List, ListItem } from "@mui/material";
import colors from "../styles/colors";

const ImprintPrivacy: React.FC = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: colors.darkGray,
      }}
    >
      <Box
        sx={{
          maxWidth: "1200px",
          width: "100%",
          p: 4,
          color: colors.antracite,
          fontSize: "0.8rem",
        }}
      >
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography variant="h2" sx={{ fontSize: "1rem", mb: 2 }}>
            Imprint
          </Typography>
          
          <Typography variant="body2" sx={{ mb: 1 }}>
            hendrik grygas
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            johannes-brahms-str. 40
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            19059 schwerin
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            germany
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Email: pidgeongirleater@gmail.com
          </Typography>
        </Box>

        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography variant="h2" sx={{ fontSize: "1rem", mb: 2 }}>
            Data Protection Policy
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            This website does not collect any personal data from its visitors.
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            We do not use:
          </Typography>
          <List
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              "& .MuiListItem-root": { 
                width: "auto",
                display: "list-item",
                p: 0,
                mb: 0.5,
                listStylePosition: "inside",
              },
            }}
          >
            <ListItem>Cookies</ListItem>
            <ListItem>Analytics tools</ListItem>
            <ListItem>User tracking</ListItem>
            <ListItem>Contact forms</ListItem>
            <ListItem>Newsletter subscriptions</ListItem>
          </List>
          <Typography variant="body2" sx={{ mb: 1, mt: 2 }}>
            This website is purely informational and does not store or process
            any personal information.
          </Typography>
          <Typography variant="body2">
            If you have any questions about our data protection policy, please
            contact us using the information provided in the imprint section
            above.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ImprintPrivacy;
